module.exports = __webpack_public_path__ + "static/img/节能减排_0.646f5d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/节能减排_0.jpg
// module id = rRYu
// module chunks = 1